import { render } from "./comunicaciones_form.vue?vue&type=template&id=43a80bb6&scoped=true"
import script from "./comunicaciones_form.vue?vue&type=script&lang=js"
export * from "./comunicaciones_form.vue?vue&type=script&lang=js"

import "./comunicaciones_form.vue?vue&type=style&index=0&id=43a80bb6&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a80bb6"]])

export default __exports__